// Convertit le rich text JSON de Shopify en HTML
function richTextToHtml(value) {
    if (!value) return '';
    let parsed;
    try {
        parsed = typeof value === 'string' ? JSON.parse(value) : value;
    } catch {
        return String(value);
    }
    function renderNode(node) {
        if (!node) return '';
        switch (node.type) {
            case 'root':
                return (node.children || []).map(renderNode).join('');
            case 'paragraph':
                return `<p>${(node.children || []).map(renderNode).join('')}</p>`;
            case 'heading': {
                const level = node.level >= 1 && node.level <= 6 ? node.level : 2;
                return `<h${level}>${(node.children || []).map(renderNode).join('')}</h${level}>`;
            }
            case 'list': {
                const tag = node.listType === 'ordered' ? 'ol' : 'ul';
                return `<${tag}>${(node.children || []).map(renderNode).join('')}</${tag}>`;
            }
            case 'list-item':
                return `<li>${(node.children || []).map(renderNode).join('')}</li>`;
            case 'link': {
                const url = node.url || '';
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${(node.children || []).map(renderNode).join('')}</a>`;
            }
            case 'text': {
                let text = (node.value || '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
                if (node.bold) text = `<strong>${text}</strong>`;
                if (node.italic) text = `<em>${text}</em>`;
                if (node.underline) text = `<u>${text}</u>`;
                if (node.strikethrough) text = `<s>${text}</s>`;
                if (node.code) text = `<code>${text}</code>`;
                return text;
            }
            default:
                return (node.children || []).map(renderNode).join('');
        }
    }
    return renderNode(parsed);
}

const state = {
    chainProducts: [],
    locketProducts: [],
    charmProducts: [],
    chainCollectionOrder: [],
    locketCollectionOrder: [],
    charmCollectionOrder: [],
    selectedChain: null,
    selectedLocket: null,
    selectedCharm: null,
    focusType: null,
    focusIndex: 0,
    activeFilter: 'ALL',
    detailsExpanded: false,
    currentFocusProducts: [],
    stickyEverShown: false
};

function imageOf(p) {
    const builderImage = p && p.builderImage;
    const featuredImage = p && p.featuredImage?.url;

    let imageUrl = builderImage || featuredImage || "";

    if (!imageUrl || typeof imageUrl !== 'string') return "";

    if (imageUrl.startsWith('gid://')) {
        console.warn('Detected GID in image URL, rejecting:', imageUrl);
        return "";
    }

    if (imageUrl.startsWith('//')) {
        return 'https:' + imageUrl;
    }

    if (!imageUrl.match(/^https?:\/\//i)) {
        console.warn('Invalid image URL format, rejecting:', imageUrl);
        return "";
    }

    return imageUrl;
}

function startLoader() {
    const bar = document.getElementById("bundle-loader-progress");
    if (!bar) return;
    bar.style.width = "0%";
    document.getElementById("bundle-loader-bar").style.display = "block";

    let width = 0;
    const interval = setInterval(() => {
        width += Math.random() * 15;
        if (width >= 90) clearInterval(interval);
        bar.style.width = width + "%";
    }, 200);

    window._bundleLoaderInterval = interval;
}

function finishLoader() {
    const bar = document.getElementById("bundle-loader-progress");
    if (!bar) return;

    clearInterval(window._bundleLoaderInterval);
    bar.style.width = "100%";

    setTimeout(() => {
        document.getElementById("bundle-loader-bar").style.display = "none";
        bar.style.width = "0%";
    }, 400);
}

function sortProductsByCollectionOrder(products, collectionOrder) {
    const orderMap = new Map();
    collectionOrder.forEach((handle, index) => {
        orderMap.set(handle, index);
    });

    return [...products].sort((a, b) => {
        const aIndex = orderMap.has(a.collectionHandle)
            ? orderMap.get(a.collectionHandle)
            : Number.MAX_SAFE_INTEGER;
        const bIndex = orderMap.has(b.collectionHandle)
            ? orderMap.get(b.collectionHandle)
            : Number.MAX_SAFE_INTEGER;
        if (aIndex !== bIndex) return aIndex - bIndex;
        // Within the same collection, sort by date descending (newest first)
        return new Date(b.createdAt) - new Date(a.createdAt);
    });
}

function getOrderedCollectionHandles(products, collectionOrder) {
    const existingHandles = new Set(
        products.map(p => p.collectionHandle).filter(Boolean)
    );
    return collectionOrder.filter(handle => existingHandles.has(handle));
}

function getFilteredProducts(products, filter) {
    if (filter === 'ALL') return products;
    return products.filter(p => p.collectionHandle === filter);
}

function productTypeClass(collectionHandle) {
    if (!collectionHandle) return '';
    return 'product-type--' + collectionHandle.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
}

function extractNumericId(gidOrId) {
    if (!gidOrId) return '';
    const str = String(gidOrId);
    if (str.startsWith('gid://')) return str.split('/').pop();
    return str;
}

document.addEventListener("DOMContentLoaded", () => {
    startLoader();

    const container = document.querySelector(".bundle-builder");
    if (!container) return;

    const data = window.__bundleBuilderData__;
    if (!data) {
        console.error("Bundle builder: window.__bundleBuilderData__ est manquant.");
        return;
    }

    state.chainCollectionOrder = data.chainCollections.map(c => c.handle);
    state.locketCollectionOrder = data.locketCollections.map(c => c.handle);
    state.charmCollectionOrder = data.charmCollections.map(c => c.handle);

    const emptyMessage = container.dataset.emptyMessage;

    window.t = {
        chain: container.dataset.tChain,
        locket: container.dataset.tLocket,
        notSelected: container.dataset.tNotSelected,
        all: container.dataset.tAll,
        added: container.dataset.tAdded,
        selectChain: container.dataset.tSelectChain,
        selectLocket: container.dataset.tSelectLocket,
        moreDetails: container.dataset.tMoreDetails,
        addToBundle: container.dataset.tAddToBundle,
        details: container.dataset.tDetails,
        yourNecklace: container.dataset.tYourNecklace,
        makeItMine: container.dataset.tMakeItMine,
        edit: container.dataset.tEdit,
        remove: container.dataset.tRemove,
        showDetails: container.dataset.tShowDetails,
        hideDetails: container.dataset.tHideDetails,
        editChain: container.dataset.tEditChain,
        editLocket: container.dataset.tEditLocket,
        charm: container.dataset.tCharm,
        selectCharm: container.dataset.tSelectCharm,
        editCharm: container.dataset.tEditCharm,
        viewProduct: container.dataset.tViewProduct
    };

    state.chainProducts = data.chainProducts || [];
    state.locketProducts = data.locketProducts || [];
    state.charmProducts = data.charmProducts || [];

    if (!state.chainProducts.length || !state.locketProducts.length) {
        container.innerHTML = emptyMessage;
        return;
    }

    finishLoader();
    container.classList.remove('loading');

    createModal();
    document.getElementById("focusBack")?.addEventListener("click", renderPreview);
    renderPreview();


    // Passer le sticky en haut quand on arrive en bas de page
    const adjustStickyPosition = () => {
        const stickies = document.querySelectorAll('.bundle-sticky');
        if (!stickies.length) return;
        const atBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 100);
        stickies.forEach(s => {
            if (atBottom) {
                s.style.bottom = 'auto';
                s.style.top = '20px';
            } else {
                s.style.top = 'auto';
                s.style.bottom = '20px';
            }
        });
    };
    window.addEventListener('scroll', adjustStickyPosition, { passive: true });
});

function formatPrice(price, currencyCode = 'USD') {
    const numPrice = typeof price === 'string' ? parseFloat(price) : price;

    // EUR : séparateur d'espace, symbole après (10 000 €)
    // Autres devises : séparateur virgule, symbole avant (10,000$)
    if (currencyCode === 'EUR') {
        const formatted = numPrice.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
        return `${formatted}\u00A0€`;
    }

    const currencySymbols = {
        'USD': '$', 'GBP': '£',
        'CAD': 'CAD $', 'AUD': 'AUD $', 'JPY': '¥',
        'CHF': 'CHF ', 'NZD': 'NZD $'
    };

    const symbol = currencySymbols[currencyCode] || '$';
    const formatted = numPrice.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${symbol}${formatted}`;
}

function updateCartUI(cart) {
    const countEl = document.getElementById("cartCount");
    if (countEl) countEl.textContent = cart.item_count;

    const totalEl = document.getElementById("cartTotal");
    if (totalEl) totalEl.textContent = `${(cart.total_price / 100).toFixed(2)}`;
}

function createModal() {
    const modalHTML = `
        <div id="productModal" class="product-modal-overlay" style="display: none;">
            <div class="product-modal">
                <button class="product-modal__close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.77933 5.08079C7.27778 3.52007 8.77624 1.95935 10.2747 0.398635C10.6435 0.0145116 10.6531 0.0106967 10.8468 0.210092C11.081 0.451708 11.3052 0.703704 11.5494 0.934938C11.6842 1.06151 11.6782 1.18447 11.4091 1.46478C8.37083 4.61932 5.33796 7.77944 2.30808 10.9427C2.08215 11.178 1.95999 11.2307 1.84094 11.0952C1.60037 10.8192 1.34701 10.5554 1.08208 10.3048C0.95314 10.182 0.997453 10.0552 1.2262 9.81815C2.74825 8.24279 4.26204 6.66112 5.77933 5.08079V5.08079Z" fill="black"/>
                        <path d="M6.91047 5.11742C8.40893 6.67814 9.90738 8.23886 11.4058 9.79958C11.7746 10.1837 11.7783 10.1937 11.5869 10.3954C11.3549 10.6394 11.1129 10.8729 10.8909 11.1272C10.7694 11.2676 10.6514 11.2614 10.3822 10.9811C7.35354 7.8166 4.31948 4.65772 1.28244 1.50194C1.05651 1.26662 1.00589 1.13939 1.13602 1.01539C1.40096 0.764821 1.65431 0.500942 1.89488 0.224994C2.01274 0.0907018 2.13456 0.136856 2.36211 0.375103C3.87462 1.9604 5.39319 3.53709 6.91047 5.11742V5.11742Z" fill="black"/>
                    </svg>
                </button>
                <div class="product-modal__body">
                    <div class="product-modal__header">
                        <div class="product-modal__header-content">
                            <h2 class="product-modal__title" id="modalTitle"></h2>
                            <p class="product-modal__price" id="modalPrice"></p>
                        </div>
                    </div>
                    <img class="product-modal__image" id="modalImage" src="" alt="">
                    <div class="product-modal__description" id="modalDescription"></div>
                    <button id="modalAddToBundle" class="product-modal__add-button"></button>
                    <a id="modalProductLink" class="product-modal__product-link" href="" target="_blank" rel="noopener noreferrer"></a>
                    <div class="product-accordion" id="modalAccordion"></div>
                </div>
            </div>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    document.querySelector('.product-modal__close')?.addEventListener('click', closeProductModal);
    document.querySelector('.product-modal-overlay')?.addEventListener('click', (e) => {
        if (e.target === e.currentTarget) closeProductModal();
    });
}

function openProductModal(product, variant) {
    const modal = document.getElementById('productModal');
    if (!modal) return;

    const modalImage = document.getElementById('modalImage');
    const modalTitle = document.getElementById('modalTitle');
    const modalPrice = document.getElementById('modalPrice');
    const modalDescription = document.getElementById('modalDescription');
    const modalAddButton = document.getElementById('modalAddToBundle');
    const modalProductLink = document.getElementById('modalProductLink');
    const modalAccordion = document.getElementById('modalAccordion');

    if (modalImage) modalImage.src = product.featuredImage?.url || '';
    if (modalTitle) modalTitle.textContent = product.title;
    if (modalPrice) modalPrice.textContent = formatPrice(variant.price, window.Shopify?.currency?.active);
    if (modalDescription) modalDescription.innerHTML = product.body || product.description || '';
    if (modalProductLink && product.url) {
        modalProductLink.href = product.url;
        modalProductLink.textContent = window.t.viewProduct;
        modalProductLink.style.display = '';
    } else if (modalProductLink) {
        modalProductLink.style.display = 'none';
    }
    if (modalAddButton) {
        modalAddButton.textContent = window.t.addToBundle;
        modalAddButton.onclick = () => {
            if (state.focusType === "chain") state.selectedChain = { product, variant };
            else if (state.focusType === "locket") state.selectedLocket = { product, variant };
            else if (state.focusType === "charm") state.selectedCharm = { product, variant };
            closeProductModal();
            renderPreview();
        };
    }

    if (modalAccordion) {
        let accordionHTML = '';

        if (product.details) {
            let detailsContent = product.details;
            if (typeof detailsContent === 'object') {
                detailsContent = detailsContent.value || JSON.stringify(detailsContent);
            }
            detailsContent = String(detailsContent);

            accordionHTML += `
                <div class="product-accordion__item">
                    <button class="product-accordion__header active" data-accordion="details">
                        <span>${window.t.details}</span>
                    </button>
                    <div class="product-accordion__content">
                        ${detailsContent}
                    </div>
                </div>
            `;
        }

        const globalTabs = window.__bundleBuilderData__?.productTabs || [];
        if (globalTabs.length > 0) {
            globalTabs.forEach((tab, index) => {
                const tabContent = richTextToHtml(tab.content);
                accordionHTML += `
                    <div class="product-accordion__item">
                        <button class="product-accordion__header" data-accordion="tab-${index}">
                            <span>${tab.title || `Tab ${index + 1}`}</span>
                        </button>
                        <div class="product-accordion__content product-accordion__content--hidden">
                            ${tabContent}
                        </div>
                    </div>
                `;
            });
        }

        modalAccordion.innerHTML = accordionHTML;

        document.querySelectorAll('.product-accordion__header').forEach(header => {
            header.addEventListener('click', toggleAccordion);
        });
    }

    modal.style.display = 'flex';
}

function closeProductModal() {
    const modal = document.getElementById('productModal');
    if (modal) modal.style.display = 'none';
}

function toggleAccordion(event) {
    event.preventDefault();
    const header = event.currentTarget;
    const content = header.nextElementSibling;
    const isActive = header.classList.contains('active');

    document.querySelectorAll('.product-accordion__header').forEach(h => h.classList.remove('active'));
    document.querySelectorAll('.product-accordion__content').forEach(c => c.classList.add('product-accordion__content--hidden'));

    if (!isActive) {
        header.classList.add('active');
        content.classList.remove('product-accordion__content--hidden');
    }
}

function renderPreview() {
    const preview = document.getElementById("previewView");
    const focusView = document.getElementById("focusView");
    if (!preview || !focusView) return;

    focusView.style.display = "none";
    preview.style.display = "flex";

    const data = window.__bundleBuilderData__;
    const defaultChainProductId = data?.defaultChainProductId;
    const defaultLocketProductId = data?.defaultLocketProductId;

    let chainProduct;
    if (state.selectedChain) {
        chainProduct = state.selectedChain.product;
    } else if (defaultChainProductId) {
        chainProduct = state.chainProducts.find(p => extractNumericId(p.id) === extractNumericId(defaultChainProductId));
    }
    if (!chainProduct) chainProduct = state.chainProducts[0];

    let locketProduct;
    if (state.selectedLocket) {
        locketProduct = state.selectedLocket.product;
    } else if (defaultLocketProductId) {
        locketProduct = state.locketProducts.find(p => extractNumericId(p.id) === extractNumericId(defaultLocketProductId));
    }
    if (!locketProduct) locketProduct = state.locketProducts[0];

    let chainImg = imageOf(chainProduct);
    let locketImg = imageOf(locketProduct);

    if (chainImg && chainImg.startsWith('gid://')) chainImg = "";
    if (locketImg && locketImg.startsWith('gid://')) locketImg = "";

    const chainButtonText = state.selectedChain ? window.t.editChain : window.t.selectChain;
    const chainButtonClass = state.selectedChain
        ? 'bundle-preview-button bundle-preview-button-chain bundle-preview-button--selected'
        : 'bundle-preview-button bundle-preview-button-chain';

    const locketButtonText = state.selectedLocket ? window.t.editLocket : window.t.selectLocket;
    const locketButtonClass = state.selectedLocket
        ? 'bundle-preview-button bundle-preview-button-locket bundle-preview-button--selected'
        : 'bundle-preview-button bundle-preview-button-locket';

    // Determine charm position based on locket presence
    const hasLocketOrScap = !!(state.selectedLocket || locketProduct);
    const charmPositionClass = hasLocketOrScap ? 'charm-img--side' : 'charm-img--center';
    const charmPositionBtnClass = hasLocketOrScap ? 'bundle-preview-button-charm--side' : 'bundle-preview-button-charm--center';

    const charmButtonText = state.selectedCharm ? window.t.editCharm : window.t.selectCharm;
    const charmButtonClass = state.selectedCharm
        ? `bundle-preview-button bundle-preview-button-charm ${charmPositionBtnClass} bundle-preview-button--selected`
        : `bundle-preview-button bundle-preview-button-charm ${charmPositionBtnClass}`;

    let charmImg = state.selectedCharm ? imageOf(state.selectedCharm.product) : '';
    if (charmImg && charmImg.startsWith('gid://')) charmImg = '';

    preview.innerHTML = `
        <button id="bundle-preview-button-chain" class="${chainButtonClass}">
            <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2172_5432)">
                    <path d="M10.9915 4.2595C11.3623 4.3421 11.7185 4.3871 12.0515 4.5014C12.666 4.7124 13.0599 5.31564 12.9924 5.87983C12.9358 6.35184 12.7436 6.76116 12.4251 7.10926C12.0682 7.49941 11.6278 7.76196 11.1512 7.96847C10.3879 8.29887 9.58119 8.44711 8.76502 8.55774C8.71134 8.56511 8.662 8.60789 8.61049 8.6337C8.65983 8.6632 8.70698 8.71261 8.75994 8.71925C9.53476 8.81955 10.3002 8.95526 11.0293 9.25468C11.532 9.46119 11.9985 9.72522 12.3845 10.1213C12.7291 10.4745 12.9293 10.8979 12.9917 11.389C13.0614 11.9385 12.6863 12.5337 12.0921 12.7601C11.8251 12.8618 11.5335 12.909 11.2484 12.9474C10.9756 12.9843 11.0162 12.9201 10.9712 13.2284C10.927 13.5293 10.8813 13.8405 10.7674 14.1178C10.446 14.9011 9.72702 15.1865 8.94639 14.8782C8.54665 14.7204 8.22236 14.4623 7.95901 14.1237C7.41707 13.4253 7.16024 12.603 6.98177 11.7504C6.90995 11.409 6.87513 11.0594 6.81564 10.715C6.80548 10.656 6.75615 10.6036 6.72495 10.5483C6.70101 10.6036 6.66183 10.6567 6.65531 10.7135C6.55156 11.6081 6.36947 12.482 5.99729 13.3058C5.75425 13.8435 5.43286 14.3214 4.93808 14.657C4.61306 14.8775 4.25685 15.0117 3.86581 14.9962C3.33911 14.9748 2.98 14.6761 2.7384 14.2181C2.536 13.8346 2.4867 13.415 2.4736 12.9762C2.2741 12.9548 2.076 12.9444 1.8823 12.9105C1.4369 12.8323 1.0364 12.6605 0.7455 12.2866C0.4538 11.9127 0.413901 11.4952 0.541601 11.0498C0.7107 10.459 1.0879 10.0305 1.5827 9.70309C2.2777 9.24436 3.05254 8.99656 3.86146 8.84979C4.14657 8.79817 4.43459 8.76203 4.71971 8.71188C4.76904 8.70303 4.81257 8.66173 4.85828 8.63518C4.81257 8.60936 4.76832 8.56659 4.72043 8.56069C3.93473 8.45596 3.15701 8.31657 2.4177 8.00977C1.9157 7.80105 1.447 7.53923 1.0676 7.13581C0.736101 6.78328 0.5213 6.37028 0.4821 5.8791C0.4335 5.26917 0.794801 4.7153 1.4151 4.5007C1.7474 4.3856 2.1036 4.3399 2.462 4.2603C2.4888 4.0567 2.5004 3.8104 2.5556 3.5744C2.6949 2.9748 2.9843 2.4806 3.61407 2.314C4.08781 2.1886 4.52093 2.3479 4.92067 2.6068C5.38353 2.9077 5.71725 3.3347 5.92547 3.8377C6.14239 4.3613 6.29401 4.9122 6.47248 5.45134C6.49497 5.51993 6.50586 5.5922 6.53342 5.66374C6.70246 3.7978 7.24005 2.0389 7.96118 0.3315L8.01995 0.319C8.14401 0.5815 8.27387 0.841199 8.38559 1.1089C8.40736 1.1605 8.36455 1.249 8.33481 1.3124C7.80665 2.4401 7.35685 3.5965 7.07246 4.8141C7.01587 5.05751 6.97742 5.30457 6.96291 5.5568C7.02893 5.30752 7.08987 5.05677 7.16242 4.809C7.33872 4.2042 7.57958 3.6297 7.97352 3.1348C8.29781 2.7277 8.70118 2.4364 9.2112 2.3184C9.84672 2.1716 10.4104 2.4357 10.7166 3.0212C10.8726 3.3185 10.9524 3.6378 10.9741 3.9726C10.9814 4.0818 10.9894 4.1909 10.9944 4.2573L10.9915 4.2595ZM6.73148 9.96933C7.46205 9.96933 8.05332 9.37416 8.05114 8.64255C8.04824 7.90209 7.4664 7.30544 6.74236 7.30249C6.00092 7.29954 5.4169 7.89029 5.4198 8.64108C5.4227 9.39039 5.99511 9.97007 6.73148 9.96933ZM1.2548 6.52516C1.4391 6.70363 1.5871 6.86146 1.7517 6.99864C1.8047 7.04289 1.9077 7.06059 1.9759 7.04289C2.7696 6.83565 3.56111 6.61808 4.35406 6.40789C4.45998 6.37987 4.51294 6.32603 4.54124 6.21835C4.75163 5.42552 4.96782 4.6349 5.17894 3.8421C5.19418 3.786 5.21014 3.702 5.18257 3.6673C5.03167 3.4755 4.86698 3.2949 4.68053 3.0802C4.64716 3.1894 4.6312 3.2351 4.61814 3.2823C4.40194 4.0737 4.1843 4.8643 3.97318 5.65637C3.94634 5.75814 3.90354 5.81051 3.80052 5.83558C3.52483 5.90196 3.25205 5.98013 2.9785 6.05462C2.4221 6.20581 1.8649 6.35848 1.2533 6.52516L1.2548 6.52516ZM12.2104 10.7474C12.0167 10.5616 11.865 10.4037 11.6989 10.2658C11.6496 10.2245 11.5502 10.2134 11.4849 10.2304C10.6854 10.4421 9.88663 10.6596 9.09004 10.8831C9.02983 10.9001 8.958 10.9709 8.94132 11.0313C8.71569 11.8397 8.49804 12.6502 8.27967 13.4607C8.26879 13.5005 8.2492 13.5558 8.26589 13.5831C8.40373 13.8037 8.56334 14.0043 8.80638 14.1518C9.01024 13.3951 9.22788 12.673 9.39257 11.9392C9.47092 11.5889 9.61892 11.4259 9.97006 11.347C10.705 11.1833 11.4276 10.9613 12.2111 10.7481L12.2104 10.7474ZM4.65732 14.2078C4.83651 14.0124 4.98959 13.859 5.12453 13.6901C5.16443 13.6399 5.17967 13.5426 5.16298 13.4777C4.95912 12.6701 4.74655 11.864 4.53906 11.0572C4.51222 10.9524 4.46361 10.8964 4.35261 10.8661C3.56546 10.653 2.7812 10.4303 1.9955 10.2134C1.9469 10.2002 1.8736 10.1854 1.8432 10.2105C1.656 10.3654 1.4775 10.5321 1.2642 10.7231C1.3904 10.7629 1.4521 10.7843 1.5152 10.802C2.2712 11.0136 3.02715 11.2268 3.78456 11.434C3.89628 11.465 3.94997 11.5166 3.98044 11.6354C4.19445 12.4717 4.41863 13.3051 4.65732 14.2078ZM12.2017 6.55244C12.1044 6.52147 12.0595 6.50524 12.0138 6.4927C11.2404 6.27514 10.4685 6.05536 9.69292 5.84443C9.57249 5.81198 9.51082 5.76109 9.48108 5.63645C9.38822 5.24926 9.28447 4.865 9.1829 4.48C9.0632 4.0272 8.94204 3.5751 8.80783 3.0721C8.63516 3.258 8.48281 3.4055 8.35367 3.5714C8.30724 3.6312 8.28548 3.7447 8.30434 3.82C8.50892 4.6275 8.72077 5.4329 8.93986 6.23679C8.958 6.30243 9.03273 6.38208 9.09729 6.40052C9.8859 6.62914 10.6774 6.84966 11.4689 7.06723C11.5219 7.08198 11.6024 7.08566 11.6387 7.05543C11.8237 6.90276 11.9985 6.73682 12.2017 6.55244ZM5.59174 4.4999C5.57868 4.5265 5.57143 4.5368 5.56853 4.5479C5.377 5.25074 5.18112 5.95285 4.99757 6.65791C4.96275 6.79213 4.89963 6.84302 4.77412 6.87547C4.10232 7.051 3.43342 7.23685 2.7638 7.41976C2.7188 7.43229 2.676 7.45073 2.6151 7.47212C3.06487 7.686 3.94561 7.88734 4.56083 7.97437C4.84377 8.01493 5.03239 7.98985 5.11437 7.68231C5.13106 7.62036 5.18474 7.56947 5.22247 7.51342C5.44157 7.18892 5.75425 6.98684 6.09813 6.84229C6.13005 6.36143 5.79488 4.7935 5.59102 4.4992L5.59174 4.4999ZM5.58521 12.8604C5.88121 12.0742 6.04009 11.3168 6.09958 10.5372C6.10321 10.4871 6.02704 10.4059 5.96972 10.3794C5.52065 10.1699 5.19998 9.83511 5.01063 9.37416C4.96782 9.27017 4.91124 9.25837 4.81692 9.27386C4.45418 9.33507 4.08708 9.3749 3.72869 9.45455C3.3645 9.53568 3.00828 9.65442 2.6484 9.75619C2.6521 9.77316 2.6557 9.79086 2.6593 9.80782C3.36812 10.0055 4.07693 10.2046 4.78645 10.3986C4.9018 10.4303 4.96492 10.4797 4.99684 10.608C5.18184 11.344 5.37917 12.0764 5.58521 12.8604ZM7.88573 4.4483C7.85454 4.5058 7.83785 4.5302 7.82769 4.5567C7.56724 5.26254 7.42868 5.99562 7.35903 6.74346C7.35468 6.78918 7.42215 6.86589 7.47366 6.88875C7.93144 7.09599 8.26081 7.43229 8.45669 7.89693C8.5082 8.01862 8.5822 8.01198 8.67143 7.99575C9.15243 7.91094 9.63561 7.8335 10.113 7.73099C10.3495 7.68084 10.5758 7.58275 10.8065 7.50605C10.089 7.26783 9.38169 7.06501 8.67143 6.87326C8.54738 6.84007 8.49441 6.77812 8.46467 6.65938C8.33481 6.14239 8.19842 5.6276 8.06348 5.11208C8.00834 4.9012 7.95102 4.691 7.88573 4.4483ZM8.5082 9.26206C8.30434 9.80413 7.94957 10.1839 7.43375 10.4096C7.39385 10.4273 7.3554 10.5151 7.36266 10.563C7.42432 10.9871 7.48164 11.4134 7.57015 11.8323C7.63834 12.1561 7.74789 12.4702 7.8393 12.7888C7.89154 12.7453 7.90532 12.7114 7.91475 12.676C8.0983 11.996 8.2862 11.3175 8.46104 10.636C8.49804 10.4915 8.56624 10.4281 8.70626 10.3941C9.04651 10.313 9.38241 10.2134 9.72049 10.1213C10.0912 10.0202 10.4619 9.91918 10.8733 9.80708C10.0869 9.47815 9.30333 9.35499 8.5082 9.26206ZM1.0575 5.97128C1.0937 5.97128 1.1184 5.97645 1.1402 5.97055C1.886 5.76921 2.6325 5.57008 3.37611 5.35915C3.43705 5.34145 3.50234 5.25368 3.52265 5.18583C3.64091 4.7802 3.74683 4.3709 3.85638 3.963C3.95287 3.6053 4.04791 3.2477 4.14367 2.8907C3.76787 2.7646 3.40658 2.9394 3.2223 3.3288C3.03005 3.7344 3.01191 4.1681 3.04093 4.6076C3.04746 4.7028 3.05109 4.7979 3.05472 4.8827C2.7863 4.8827 2.5389 4.8717 2.293 4.8849C1.9077 4.9056 1.5363 4.9771 1.2424 5.26548C1.0415 5.4624 0.990001 5.69693 1.056 5.97202L1.0575 5.97128ZM9.3338 2.8737C9.52025 3.5781 9.72049 4.2536 9.87139 4.9395C9.93886 5.24631 10.0731 5.38054 10.3698 5.45208C11.0489 5.61654 11.7178 5.82304 12.3946 6.01332C12.4737 5.79207 12.4527 5.58778 12.3344 5.40561C12.1973 5.19468 11.9942 5.06193 11.7569 4.9852C11.3877 4.8658 11.0097 4.8599 10.6281 4.8916C10.5592 4.8975 10.4902 4.8989 10.4228 4.9026C10.4228 4.6002 10.4344 4.3237 10.4199 4.0493C10.401 3.6879 10.3168 3.3435 10.06 3.0714C9.86559 2.8649 9.6298 2.7978 9.3338 2.8737ZM10.3879 12.3906C10.6818 12.3906 10.9342 12.4009 11.186 12.3884C11.5589 12.3699 11.9165 12.2947 12.206 12.0255C12.4222 11.8242 12.4875 11.5727 12.3881 11.288C11.6147 11.4982 10.8399 11.7069 10.0673 11.9237C10.0194 11.937 9.96933 12.0093 9.9541 12.0639C9.75168 12.7888 9.55435 13.516 9.35702 14.2425C9.34324 14.2926 9.34033 14.3457 9.33235 14.3996C9.66535 14.4836 9.94031 14.404 10.1159 14.1326C10.2385 13.943 10.3502 13.7181 10.3763 13.4983C10.4191 13.1362 10.3879 12.7652 10.3879 12.3906ZM3.06124 12.4039C3.05472 12.4983 3.04673 12.5949 3.04093 12.6915C3.01554 13.1369 3.03223 13.5765 3.24262 13.9829C3.43342 14.3516 3.75699 14.5028 4.11248 14.3915C4.10885 14.3568 4.10957 14.3199 4.10014 14.2853C3.90644 13.5455 3.70838 12.8065 3.52048 12.0646C3.48928 11.9429 3.41093 11.9178 3.31662 11.8913C2.6194 11.6966 1.9222 11.5011 1.225 11.3064C1.175 11.2924 1.1227 11.2873 1.0589 11.2762C0.998 11.5432 1.027 11.774 1.2091 11.9717C1.4166 12.1966 1.6799 12.3205 1.9745 12.35C2.3263 12.3854 2.6818 12.3862 3.06197 12.4031L3.06124 12.4039Z" fill="black"/>
                </g>
                <defs>
                    <clipPath id="clip0_2172_5432">
                        <rect width="13" height="15" fill="white" transform="translate(13 15) rotate(-180)"/>
                    </clipPath>
                </defs>
            </svg>

            ${chainButtonText}
        </button>
        <img class="chain-img ${productTypeClass(chainProduct?.collectionHandle)}" src="${chainImg}" style="opacity:${state.selectedChain ? 1 : 0.3};">
        <img class="locket-img ${productTypeClass(locketProduct?.collectionHandle)}" src="${locketImg}" style="opacity:${state.selectedLocket ? 1 : 0.3};">
        ${charmImg ? `<img class="charm-img ${charmPositionClass}" src="${charmImg}">` : ''}
        <button id="bundle-preview-button-locket" class="${locketButtonClass}">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 7.3348C0.891777 7.12262 1.70121 6.92708 2.51063 6.73778C3.45664 6.51728 4.40064 6.28846 5.34865 6.08876C5.67604 6.02011 5.86082 5.87449 5.98334 5.5375C6.57786 3.88374 7.2005 2.24038 7.8151 0.592858C7.88138 0.418121 7.9577 0.247544 8.05813 0C8.3594 0.555414 8.62854 1.04842 8.89568 1.54559C9.5384 2.73963 10.2012 3.92534 10.8138 5.1381C11.0086 5.52502 11.2697 5.62487 11.6413 5.65399C13.3927 5.78921 15.1421 5.94106 17 6.095C16.8574 6.28429 16.767 6.41327 16.6686 6.53392C15.578 7.87149 14.4914 9.21322 13.3867 10.5362C13.1557 10.8129 13.0854 11.0584 13.1718 11.4224C13.5976 13.2031 13.9973 14.992 14.403 16.7768C14.4291 16.8913 14.4351 17.0098 14.4612 17.197C14.2604 17.1138 14.1098 17.0577 13.9672 16.989C12.4668 16.2693 10.9604 15.5599 9.47011 14.8131C9.13469 14.6446 8.90974 14.6821 8.61248 14.8859C7.10811 15.9156 5.58967 16.9225 3.98488 18C4.03107 17.3884 4.06723 16.8684 4.11342 16.3483C4.23996 14.8984 4.35645 13.4485 4.5091 12.0007C4.54726 11.6387 4.42876 11.4286 4.18372 11.2061C2.93845 10.0744 1.70522 8.92615 0.469991 7.78412C0.335421 7.65931 0.202859 7.53034 0 7.33688L0 7.3348Z" fill="#000000"/>
            </svg>
            ${locketButtonText}
        </button>
        ${state.charmProducts.length ? `
        <button id="bundle-preview-button-charm" class="${charmButtonClass}">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 7.3348C0.891777 7.12262 1.70121 6.92708 2.51063 6.73778C3.45664 6.51728 4.40064 6.28846 5.34865 6.08876C5.67604 6.02011 5.86082 5.87449 5.98334 5.5375C6.57786 3.88374 7.2005 2.24038 7.8151 0.592858C7.88138 0.418121 7.9577 0.247544 8.05813 0C8.3594 0.555414 8.62854 1.04842 8.89568 1.54559C9.5384 2.73963 10.2012 3.92534 10.8138 5.1381C11.0086 5.52502 11.2697 5.62487 11.6413 5.65399C13.3927 5.78921 15.1421 5.94106 17 6.095C16.8574 6.28429 16.767 6.41327 16.6686 6.53392C15.578 7.87149 14.4914 9.21322 13.3867 10.5362C13.1557 10.8129 13.0854 11.0584 13.1718 11.4224C13.5976 13.2031 13.9973 14.992 14.403 16.7768C14.4291 16.8913 14.4351 17.0098 14.4612 17.197C14.2604 17.1138 14.1098 17.0577 13.9672 16.989C12.4668 16.2693 10.9604 15.5599 9.47011 14.8131C9.13469 14.6446 8.90974 14.6821 8.61248 14.8859C7.10811 15.9156 5.58967 16.9225 3.98488 18C4.03107 17.3884 4.06723 16.8684 4.11342 16.3483C4.23996 14.8984 4.35645 13.4485 4.5091 12.0007C4.54726 11.6387 4.42876 11.4286 4.18372 11.2061C2.93845 10.0744 1.70522 8.92615 0.469991 7.78412C0.335421 7.65931 0.202859 7.53034 0 7.33688L0 7.3348Z" fill="#000000"/>
            </svg>
            ${charmButtonText}
        </button>` : ''}
    `;

    document.getElementById('bundle-preview-button-chain')?.addEventListener('click', () => openFocus('chain'));
    document.getElementById('bundle-preview-button-locket')?.addEventListener('click', () => openFocus('locket'));
    document.getElementById('bundle-preview-button-charm')?.addEventListener('click', () => openFocus('charm'));

    const locketBtn = document.getElementById('bundle-preview-button-locket');
    if (locketBtn && locketProduct?.collectionHandle === 'scapulaires') {
        if (window.innerWidth <= 768) {
            locketBtn.style.transform = 'translateY(-120px)';
        } else {
            locketBtn.style.transform = 'translateX(150px)';
        }
    }

    updateStickySummary();
}

function openFocus(type) {
    state.focusType = type;
    state.focusIndex = 0;
    state.activeFilter = 'ALL';

    const preview = document.getElementById("previewView");
    const focusView = document.getElementById("focusView");
    if (!preview || !focusView) return;

    preview.style.display = "none";
    focusView.style.display = "flex";

    // Scroller pour que les filtres soient visibles sous le header
    const focusHeader = focusView.querySelector('.bundle-focus__header');
    if (focusHeader) {
        const headerGroup = document.getElementById('header-group');
        const headerHeight = headerGroup ? headerGroup.getBoundingClientRect().bottom : 0;
        const top = focusHeader.getBoundingClientRect().top + window.scrollY - headerHeight - 10;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    document.querySelectorAll(".bundle-sticky").forEach(sticky => {
        sticky.classList.add("hidden");
    });

    updateFocus();
}

// FIX: fonction centralisée pour mettre à jour titre/prix/boutons
// en lisant toujours depuis state.currentFocusProducts + index courant
function renderFocusInfo(index) {
    const product = state.currentFocusProducts[index];
    if (!product) return;

    // Les produits hors stock étant filtrés en amont, on a toujours une variante dispo
    const variant = product.variants.find(v => v.availableForSale);
    if (!variant) return;

    const focusTitle = document.getElementById("focusTitle");
    const focusPrice = document.getElementById("focusPrice");
    if (focusTitle) focusTitle.textContent = product.title;
    if (focusPrice) focusPrice.textContent = formatPrice(variant.price, window.Shopify?.currency?.active);

    // Reset complet du conteneur details
    const detailBtn = document.querySelector("#focusDetailsBtn");
    if (detailBtn) {
        detailBtn.innerHTML = '';
        const detailsButton = document.createElement('button');
        detailsButton.className = 'bundle-details-button';
        detailsButton.textContent = window.t.moreDetails;
        detailsButton.onclick = () => openProductModal(product, variant);
        detailBtn.appendChild(detailsButton);
    }

    // Reset du bouton add
    const focusAdd = document.getElementById("focusAdd");
    if (focusAdd) {
        focusAdd.disabled = false;
        focusAdd.style.opacity = '1';
        focusAdd.style.cursor = 'pointer';
        focusAdd.onclick = () => {
            if (state.focusType === "chain") state.selectedChain = { product, variant };
            else if (state.focusType === "locket") state.selectedLocket = { product, variant };
            else if (state.focusType === "charm") state.selectedCharm = { product, variant };
            renderPreview();
        };
    }
}

function updateFocus() {
    if (!state.focusType) return;

    const allProducts = state.focusType === "chain" ? state.chainProducts
        : state.focusType === "locket" ? state.locketProducts
        : state.charmProducts;
    const collectionOrder = state.focusType === "chain" ? state.chainCollectionOrder
        : state.focusType === "locket" ? state.locketCollectionOrder
        : state.charmCollectionOrder;

    let products = getFilteredProducts(allProducts, state.activeFilter);
    if (state.activeFilter === 'ALL') {
        products = sortProductsByCollectionOrder(products, collectionOrder);
    } else {
        products = [...products].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }

    products = products.filter(p => p.variants.some(v => v.availableForSale));

    state.currentFocusProducts = products;
    state.focusIndex = 0;

    // Rendu des boutons de filtre
    const filtersContainer = document.getElementById("focusFilters");
    if (filtersContainer) {
        const handles = getOrderedCollectionHandles(allProducts, collectionOrder);
        const collections = state.focusType === "chain"
            ? window.__bundleBuilderData__.chainCollections
            : state.focusType === "locket"
            ? window.__bundleBuilderData__.locketCollections
            : window.__bundleBuilderData__.charmCollections;
        const collectionTitleMap = new Map(collections.map(c => [c.handle, c.title]));

        filtersContainer.innerHTML = '';

        const allBtn = document.createElement('button');
        allBtn.textContent = window.t.all;
        allBtn.className = state.activeFilter === 'ALL' ? 'active' : '';
        allBtn.onclick = () => {
            state.activeFilter = 'ALL';
            updateFocus();
        };
        filtersContainer.appendChild(allBtn);

        handles.forEach(handle => {
            const btn = document.createElement('button');
            btn.textContent = collectionTitleMap.get(handle) || handle;
            btn.className = state.activeFilter === handle ? 'active' : '';
            btn.onclick = () => {
                state.activeFilter = handle;
                updateFocus();
            };
            filtersContainer.appendChild(btn);
        });
    }

    const track = document.getElementById("sliderTrack");
    if (!track) return;

    track.innerHTML = "";

    products.forEach((p) => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide " + productTypeClass(p.collectionHandle);

        if (p.builderBackgroundImage) {
            const bgDiv = document.createElement("div");
            bgDiv.className = "swiper-slide-background";
            bgDiv.style.backgroundImage = `url(${p.builderBackgroundImage})`;
            slide.appendChild(bgDiv);
        }

        const img = document.createElement("img");
        let imgSrc = imageOf(p);
        if (imgSrc && imgSrc.startsWith('gid://')) imgSrc = "";

        img.src = imgSrc;
        img.alt = p.title || "";
        img.className = "swiper-slide-product-image " + state.focusType + " " + productTypeClass(p.collectionHandle);

        slide.appendChild(img);
        track.appendChild(slide);
    });

    if (window.currentSwiper) {
        window.currentSwiper.off('slideChange');
        window.currentSwiper.destroy(true, true);
        window.currentSwiper = null;
    }

    const updatePagination = (currentIndex, total) => {
        const paginationEl = document.querySelector('.bundle-focus__pagination');
        if (paginationEl) paginationEl.textContent = `${currentIndex + 1}/${total}`;
    };

    updatePagination(0, products.length);

    window.currentSwiper = new Swiper('.bundle-focus__swiper', {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 30,
        initialSlide: 0,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: function () {
                state.focusIndex = this.activeIndex;
                updatePagination(this.activeIndex, state.currentFocusProducts.length);
                renderFocusInfo(this.activeIndex);
            }
        }
    });

    // Rendu initial du premier slide (slideChange ne fire pas au init)
    renderFocusInfo(0);
}

function updateStickySummary(cart) {
    const stickies = document.querySelectorAll(".bundle-sticky");
    if (!stickies.length) return;

    stickies.forEach(sticky => {
        const hasAnySelection = !!(state.selectedChain || state.selectedLocket || state.selectedCharm);

        if (hasAnySelection) {
            state.stickyEverShown = true;
        } else {
            state.stickyEverShown = false;
        }

        if (!state.stickyEverShown) {
            sticky.classList.add("hidden");
            return;
        }

        sticky.classList.remove("hidden");

        const currencyCode = cart?.currency || window.Shopify?.currency?.active || 'EUR';

        let total = 0;
        if (cart?.total_price) {
            total = cart.total_price / 100;
        } else {
            if (state.selectedChain) total += parseFloat(state.selectedChain.variant.price);
            if (state.selectedLocket) total += parseFloat(state.selectedLocket.variant.price);
            if (state.selectedCharm) total += parseFloat(state.selectedCharm.variant.price);
        }

        const toggleLabel = state.detailsExpanded ? window.t.hideDetails : window.t.showDetails;
        const detailsExpandedClass = state.detailsExpanded ? 'bundle-sticky-details--expanded' : '';
        const toggleActiveClass = state.detailsExpanded ? 'bundle-sticky-toggle--active' : '';

        const chainImage = imageOf(state.selectedChain?.product);
        const locketImage = imageOf(state.selectedLocket?.product);
        const charmImage = imageOf(state.selectedCharm?.product);

        sticky.innerHTML = `
            <div class="bundle-sticky-content">
                <div class="bundle-sticky-header">
                    <button class="bundle-sticky-toggle ${toggleActiveClass}" aria-label="${toggleLabel}">
                        <span class="bundle-sticky-toggle-icon">
                            <svg width="16" height="9" viewBox="0 0 16 9" fill="black" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.93456 7.31964L14.9109 9.64352e-07L16 1.14155L8.98747 8.49916C8.41292 9.1681 7.45081 9.16694 6.8776 8.49569L4.96958e-07 1.13588L1.09978 0.0056589L7.93456 7.31964Z" fill="black"/>
                            </svg>
                        </span>
                    </button>
                    <div class="bundle-sticky-header-text">
                        <h3 class="bundle-sticky-title">${window.t.yourNecklace}</h3>
                        <p class="bundle-sticky-total">${formatPrice(total, currencyCode)}</p>
                    </div>
                    <button class="bundle-sticky-cta" id="stickyAddToCart">
                        ${window.t.makeItMine}
                    </button>
                </div>
                <div class="bundle-sticky-details ${detailsExpandedClass}">
                    ${state.selectedChain ? `
                    <div class="bundle-sticky-item">
                        <img class="bundle-sticky-item-image" src="${chainImage}" alt="${state.selectedChain.product.title}">
                        <div class="bundle-sticky-item-info">
                            <p class="bundle-sticky-item-title">${state.selectedChain.product.title}</p>
                            <p class="bundle-sticky-item-price">${formatPrice(state.selectedChain.variant.price, currencyCode)}</p>
                        </div>
                        <div class="bundle-sticky-item-actions">
                            <button class="bundle-sticky-item-edit" data-type="chain">${window.t.edit}</button>
                            <button class="bundle-sticky-item-remove" data-type="chain">${window.t.remove}</button>
                        </div>
                    </div>` : ''}
                    ${state.selectedLocket ? `
                    <div class="bundle-sticky-item">
                        <img class="bundle-sticky-item-image" src="${locketImage}" alt="${state.selectedLocket.product.title}">
                        <div class="bundle-sticky-item-info">
                            <p class="bundle-sticky-item-title">${state.selectedLocket.product.title}</p>
                            <p class="bundle-sticky-item-price">${formatPrice(state.selectedLocket.variant.price, currencyCode)}</p>
                        </div>
                        <div class="bundle-sticky-item-actions">
                            <button class="bundle-sticky-item-edit" data-type="locket">${window.t.edit}</button>
                            <button class="bundle-sticky-item-remove" data-type="locket">${window.t.remove}</button>
                        </div>
                    </div>` : ''}
                    ${state.selectedCharm ? `
                    <div class="bundle-sticky-item">
                        <img class="bundle-sticky-item-image" src="${charmImage}" alt="${state.selectedCharm.product.title}">
                        <div class="bundle-sticky-item-info">
                            <p class="bundle-sticky-item-title">${state.selectedCharm.product.title}</p>
                            <p class="bundle-sticky-item-price">${formatPrice(state.selectedCharm.variant.price, currencyCode)}</p>
                        </div>
                        <div class="bundle-sticky-item-actions">
                            <button class="bundle-sticky-item-edit" data-type="charm">${window.t.edit}</button>
                            <button class="bundle-sticky-item-remove" data-type="charm">${window.t.remove}</button>
                        </div>
                    </div>` : ''}
                </div>
            </div>
        `;

        const toggleBtn = sticky.querySelector('.bundle-sticky-toggle');
        if (toggleBtn) {
            toggleBtn.addEventListener('click', () => {
                state.detailsExpanded = !state.detailsExpanded;
                const details = sticky.querySelector('.bundle-sticky-details');
                if (!details) return;
                toggleBtn.classList.toggle('bundle-sticky-toggle--active');
                details.classList.toggle('bundle-sticky-details--expanded');
            });
        }

        sticky.querySelectorAll('.bundle-sticky-item-edit').forEach(btn => {
            btn.addEventListener('click', (e) => {
                openFocus(e.currentTarget.dataset.type);
            });
        });

        sticky.querySelectorAll('.bundle-sticky-item-remove').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const type = e.currentTarget.dataset.type;
                if (type === 'chain') state.selectedChain = null;
                else if (type === 'locket') state.selectedLocket = null;
                else if (type === 'charm') state.selectedCharm = null;
                renderPreview();
            });
        });

        const addToCartBtn = sticky.querySelector('#stickyAddToCart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', async () => {
                if (!state.selectedChain && !state.selectedLocket) return;

                const items = [
                    state.selectedChain ? { id: extractNumericId(state.selectedChain.variant.id), quantity: 1 } : null,
                    state.selectedLocket ? { id: extractNumericId(state.selectedLocket.variant.id), quantity: 1 } : null,
                    state.selectedCharm ? { id: extractNumericId(state.selectedCharm.variant.id), quantity: 1 } : null,
                ].filter(Boolean);

                try {
                    await fetch(Theme.routes.cart_add_url, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ items })
                    });

                    const cartResponse = await fetch(Theme.routes.cart_url + '.js');
                    const updatedCart = await cartResponse.json();

                    updateCartUI(updatedCart);
                    addToCartBtn.textContent = window.t.added;
                    window.location.href = Theme.routes.cart_url;
                } catch (err) {
                    console.error("Error adding to cart:", err);
                }
            });
        }
    });
}